import { forBrands, styled, Brands } from '@core-ui/react-stitch';

export const PriceStyleContainer = styled.div(({ theme }) => {
  const priceColor = forBrands(theme, {
    gap: theme.color.g2,
    gapfs: theme.color.g2,
    br: theme.color.g2,
    brfs: theme.color.g2,
    on: theme.color.bk,
    at: theme.color.bk,
  });

  const priceFont = forBrands(theme, {
    on: theme.font.primary,
    at: theme.font.primary,
  });

  const priceHighlightFont = forBrands(theme, {
    gap: theme.font.primary,
    gapfs: theme.font.primary,
    on: theme.font.primary,
    at: theme.font.primary,
    br: theme.font.secondary,
    brfs: theme.font.secondary,
  });

  const priceBananaRepublicHighlightFont = forBrands(theme, {
    br: theme.font.primary,
    brfs: theme.font.primary,
  });

  const priceBRFactoryColor = forBrands(theme, {
    brfs: theme.color.r1,
    br: theme.color.r1,
  });

  const priceBananaRepublicPercentageOffColor = forBrands(theme, {
    br: theme.color.b1,
  });

  const priceOptionStyles = forBrands(theme, {
    br: theme.color.b1,
    brfs: theme.color.b1,
  });

  const productPriceStyle = {
    '.product-price': {
      '&__markdown, &--markdown': {
        color: theme.color.g2,
      },
      '&__highlight, &--highlight': {
        textTransform: 'none',
        color: theme.color.r1,
        ...priceHighlightFont,
      },
      '&__highlight--br, &--highlight-brff': {
        textTransform: 'none',
        fontSize: '0.8125rem',
        ...priceBananaRepublicHighlightFont,
        color: priceBRFactoryColor,
      },
      '&__markdown': {
        textTransform: 'none',
        color: theme.color.g2,
      },
      '&__no-strike': {
        ...theme.font.primary,
      },
      '&__option': {
        ...priceOptionStyles,
        ...theme.font.secondary,
      },
      '&__option--br': {
        ...priceOptionStyles,
        ...theme.font.primary,
      },
      '&__percentage-off': {
        color: theme.color.r1,
        ...theme.font.primary,
        textTransform: 'none',
        paddingLeft: '5px',
      },
      '&__percentage-off--br': {
        color: priceBananaRepublicPercentageOffColor,
      },
      '&__regular': {
        ...theme.font.primary,
      },
      '&__sale': {
        color: theme.color.g2,
      },
      '&__strike': {
        textDecoration: 'line-through',
        ...theme.font.primary,
      },
    },
  };

  return {
    textTransform: 'none',
    lineHeight: '1.4',
    color: priceColor,
    fontSize: '0.8rem !important',
    letterSpacing: theme.brand === Brands.Athleta ? '1px' : 'normal',
    ...theme.brandFont,
    ...priceFont,
    ...productPriceStyle,
  };
});

export const PriceLineDiv = styled.div`
  > div {
    display: inline-block;
    margin-right: 5px;
  }
`;
